import { render } from "./PaymentsCreate.vue?vue&type=template&id=175048dc"
import script from "./PaymentsCreate.vue?vue&type=script&lang=js"
export * from "./PaymentsCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__